import { Location } from "react-router-dom-v5-compat";

import { StateParamType } from "seneca-common/utils/routing/react-router-typesafe-routes/common";
import { PartialExcept } from "common/types";

import { ClassAndAssignment } from "features/teachers/pages/assignment/modals/MultipleAssignmentShareModal/hooks/useSortAssignmentsAlphabeticallyByClassName";

type PartialLocation = PartialExcept<Location, "pathname">;

export const locationType: StateParamType<Location, PartialLocation> = {
  getPlainStateParam(value: PartialLocation) {
    return value;
  },
  getTypedStateParam(value) {
    return value as Location;
  }
};

export const classAndAssignmentArrayType: StateParamType<
  ClassAndAssignment[],
  ClassAndAssignment[]
> = {
  getPlainStateParam(value: ClassAndAssignment[]) {
    return value;
  },
  getTypedStateParam(value) {
    return value as ClassAndAssignment[];
  }
};
